import './polyfill';
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import App from './App';
import router from './router';
import store from './store/index';
import Axios from 'axios';
import jwtToken from './helpers/jwt-token';
import validator from './helpers/validator';
import user from './helpers/user';
import form from './helpers/form';
import { apiDomain } from './config.js';
import Swal from 'sweetalert2';
import {loadingMixin} from './mixins/loading-mixin';
import {loggerMixin} from './mixins/logger-mixin';
import {permissionsMixin} from './mixins/permissions-mixin';
import {rolesMixin} from './mixins/roles-mixin';
import {notificationMixin} from './mixins/notification-mixin';
import {validateStateMixin} from './mixins/validate_state-mixin';
import Loading from './components/Loading';
import VueNotifications from 'vue-notifications';
import miniToastr from 'mini-toastr';
import VueFilterDateFormat from 'vue-filter-date-format';
import ToggleButton from 'vue-js-toggle-button';
import VCalendar from 'v-calendar';
import wysiwyg from "vue-wysiwyg";
import CKEditor from '@ckeditor/ckeditor5-vue2';

// Use v-calendar, v-date-picker & v-popover components
Vue.use(VCalendar, {
    firstDayOfWeek: 2,
});

// TOSTR notifications
const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
};

miniToastr.init({types: toastTypes});

function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
}

const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
};

Vue.use(VueNotifications, options);
Vue.use(VueFilterDateFormat);
Vue.use(ToggleButton);

let filter = function(text, length, clamp){
    clamp = clamp || '...';
    return text.length > length ? text.slice(0, length) + clamp : text;
};

Vue.filter('truncate', filter);

// wysiwyg

Vue.use(wysiwyg, {});
Vue.use( CKEditor );

// cssVars()
Vue.use(BootstrapVue);
window.swal = Swal;

// Axios interceptors for JWT
window.axios = require('axios');
axios.defaults.baseURL =  apiDomain;

axios.interceptors.request.use(config => {
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    if (jwtToken.getToken() && config.url !== 'login') {
        config.headers['Authorization'] = 'Bearer ' + jwtToken.getToken();
    }
    return config;
}, error => {
    return Promise.reject(error);
});

axios.interceptors.response.use(response => {
    return response;
}, error => {
    let errorResponseData = error.response.data;
    const errors = ["token_invalid", "token_expired", "token_not_provided","Expired JWT Token","JWT Token not found"];

    if (errors.includes(errorResponseData.message) || error.response.status === 420) {
        store.dispatch('unsetAuthUser')
            .then(() => {
                jwtToken.removeToken();
                router.push({name: 'login'});
            });
    }
    return Promise.reject(error);
});

// global event bus
Vue.prototype.$eventHub = new Vue();

// global mixins
Vue.mixin(loadingMixin);
Vue.mixin(loggerMixin);
Vue.mixin(permissionsMixin);
Vue.mixin(rolesMixin);
Vue.mixin(notificationMixin);
Vue.mixin(validateStateMixin);

// global components
Vue.component("loading", Loading);

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: {
        App,
    }
});